// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__21AXt","name":"ConsentHeader_name__3lVNP","birthday":"ConsentHeader_birthday__1CiqS","skeleton":"ConsentHeader_skeleton__3dfyF"};